import { MonitorPeriod } from '../../../../types/monitor/MonitorPeriod';
import { MonitorType } from '../../../../types/monitor/MonitorType';
import { KeywordsDailyStatsMultipleResponse } from '../../../../models/monitor/keywords/stats/KeywordsDailyStatsResponse';
import { ProjectStatsResponse } from './MonitorPromptsKeywordsStatsResponse';
import { getDefaultRange } from '../../../../utils/utils';
import { client } from '../../../apiClient';
import { format } from 'date-fns';
import { PeriodType } from '../../../../types/prompt/PeriodType';
import { ChatType } from '../../../../types/monitor/ChatType';
import { KEYWORDS_ENDPOINT } from '../KeywordsService';

export const STATS_ENDPOINT = `${KEYWORDS_ENDPOINT}/stats`;

export const getKeywordsDailyStats = async (
  id: string,
  period?: MonitorPeriod | 'DAILY',
  type?: MonitorType | 'ALL',
  from?: Date | null,
  to?: Date | null,
  models?: string[]
): Promise<KeywordsDailyStatsMultipleResponse> => {
  const defaultRange = getDefaultRange();
  from = from ? new Date(from) : defaultRange[0];
  to = to ? new Date(to) : defaultRange[1];

  const formattedFrom = format(from, 'yyyy-MM-dd');
  const formattedTo = format(to, 'yyyy-MM-dd');

  const modelsParam = models && models.length > 0 ? `?models=${models.join(',')}` : '';

  return client(true, true)
    .get<KeywordsDailyStatsMultipleResponse>(
      `${STATS_ENDPOINT}/${id}/${period}/${type}/${formattedFrom}/${formattedTo}${modelsParam}`
    )
    .then((response) => response.data)
    .catch((error) => error);
};

export const getKeywordsDailyStatsForProject = async (
  projectId: number,
  chatType: ChatType,
  period?: PeriodType | 'DAILY',
  from?: Date | null,
  to?: Date | null
): Promise<ProjectStatsResponse> => {
  const defaultRange = getDefaultRange();
  from = from ? new Date(from) : defaultRange[0];
  to = to ? new Date(to) : defaultRange[1];

  const formattedFrom = format(from, 'yyyy-MM-dd');
  const formattedTo = format(to, 'yyyy-MM-dd');

  const { data } = await client(true, true).get<ProjectStatsResponse>(
    `${STATS_ENDPOINT}/project/${projectId}/${chatType}/${period}/${formattedFrom}/${formattedTo}`
  );
  return data;
};

export const exportPromptStats = async (
  promptId: number,
  chatType: ChatType,
  from?: Date | null,
  to?: Date | null
): Promise<Blob> => {
  const defaultRange = getDefaultRange();
  from = from ? new Date(from) : defaultRange[0];
  to = to ? new Date(to) : defaultRange[1];

  const formattedFrom = format(from, 'yyyy-MM-dd');
  const formattedTo = format(to, 'yyyy-MM-dd');

  return client(true, true)
    .get<Blob>(
      `${STATS_ENDPOINT}/export-stats/${promptId}/${formattedFrom}/${formattedTo}/${chatType}`,
      {
        responseType: 'blob',
      }
    )
    .then((response) => response.data)
    .catch((error) => error);
};
